const salesStrategy = {
  none: 0,
  flagShipAccount: 1,
  investToGrow: 2,
  maintain: 3,
  serveEfficiently: 4,
}

export default salesStrategy;